{
  "chart": "환자 차트",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "인적 사항",
    "loading": "환자 인적 사항을 불러오는 중입니다...",
    "loadError": "환자 인적 사항을 불러오지 못했습니다.",
    "returnToDashboard": "대시보드로 돌아가기",
    "updatedSuccess": "환자 인적 사항이 업데이트되었습니다",
    "updateError": "환자 인적 사항 업데이트에 실패했습니다",
    "sections": {
      "personalInformation": "개인 정보",
      "identification": "신분증",
      "contactInformation": "연락처",
      "address": "주소",
      "languageAndPreferences": "언어 및 선호",
      "specialFlags": "특수 표시",
      "recordInformation": "기록 정보"
    },
    "fields": {
      "fullName": "성명",
      "alternativeName": "다른 이름",
      "preferredName": "통칭",
      "dateOfBirth": "생년월일",
      "birthTime": "출생 시각",
      "age": "나이",
      "legalGender": "법적 성별",
      "genderIdentity": "성 정체성",
      "sexAtBirth": "출생 시 성별",
      "race": "인종",
      "ethnicity": "민족",
      "nationality": "국적",
      "mrn": "MRN",
      "nationalIdType": "신분증 유형",
      "nationalIdNumber": "신분증 번호",
      "passportNumber": "여권 번호",
      "passportCountry": "여권 발급국",
      "primaryPhone": "주 전화번호",
      "mobilePhone": "휴대전화",
      "email": "이메일",
      "preferredContactMethod": "선호 연락 방법",
      "addressLine1": "주소 1행",
      "addressLine2": "주소 2행",
      "city": "시/군/구",
      "stateProvince": "시·도",
      "postalCode": "우편번호",
      "country": "국가",
      "primaryLanguage": "주 사용 언어",
      "secondaryLanguage": "부 사용 언어",
      "interpreterRequired": "통역 필요",
      "vipStatus": "VIP 상태",
      "confidentialityLevel": "기밀 등급",
      "medicalTourist": "의료관광객",
      "homeCountry": "본국",
      "status": "상태",
      "deceased": "사망",
      "created": "생성 시각",
      "lastModified": "최종 수정",
      "passportOnFile": "여권 보관됨",
      "organDonorStatus": "장기기증 상태"
    },
    "statusValues": {
      "active": "활성",
      "inactive": "비활성"
    },
    "deceasedSummary": "예 ({{date}})",
    "deceasedDateUnknown": "날짜 미상",
    "legalGender": {
      "label": "법적 성별",
      "values": {
        "male": "남성",
        "female": "여성",
        "other": "기타",
        "unknown": "미상"
      },
      "selectPlaceholder": "성별 선택"
    },
    "sexAtBirth": {
      "label": "출생 시 성별",
      "values": {
        "female": "여성",
        "male": "남성",
        "other": "기타",
        "unknown": "알 수 없음"
      },
      "notRecorded": "기록 없음"
    },
    "preferredContactMethod": {
      "label": "선호 연락 방법",
      "values": {
        "phone": "전화",
        "mobile": "휴대전화",
        "email": "이메일",
        "sms": "SMS"
      },
      "notSpecified": "지정되지 않음"
    },
    "validation": {
      "fullNameRequired": "성명은 필수 항목입니다",
      "dateOfBirthRequired": "생년월일은 필수 항목입니다",
      "countryRequired": "국가는 필수 항목입니다",
      "primaryLanguageRequired": "주 사용 언어는 필수 항목입니다",
      "invalidEmail": "이메일 형식이 올바르지 않습니다",
      "nationalIdValidationFailed": "신분증 번호 검증에 실패했습니다: {{error}}",
      "invalidBirthTime": "출생 시각은 HH:MM 형식이어야 합니다"
    },
    "organDonor": {
      "notRecorded": "미기록",
      "registered": "기증 등록됨",
      "optedOut": "기증 거부",
      "notRegistered": "미등록",
      "unknown": "알 수 없음"
    }
  },
  "registration": {
    "title": "환자 등록",
    "subtitle": "새 환자를 시스템에 등록합니다",
    "submit": "환자 등록",
    "submitting": "등록 중...",
    "checkingDuplicates": "중복 확인 중...",
    "registerNew": "신규 환자 등록",
    "registeredSuccess": "환자가 정상적으로 등록되었습니다",
    "registerError": "환자 등록에 실패했습니다",
    "validationNationalIdFailed": "신분증 번호 검증에 실패했습니다: {{error}}",
    "sections": {
      "basicInformation": "기본 정보",
      "identification": "신분증",
      "contactInformation": "연락처",
      "address": "주소",
      "languageAndCommunication": "언어 및 의사소통",
      "additionalInformation": "추가 정보"
    },
    "fields": {
      "facility": "등록 기관"
    },
    "placeholders": {
      "fullName": "예: Tan Wei Ming 또는 김민준",
      "alternativeName": "해당 시 로마자 표기",
      "preferredName": "환자가 선호하는 호칭",
      "nationalIdNumberDefault": "신분증 번호를 입력하세요",
      "primaryPhone": "+82 10-1234-5678",
      "mobilePhone": "+82 10-1234-5678",
      "email": "patient@example.com",
      "facility": "기관을 선택하세요"
    },
    "helperText": {
      "fullName": "공식 신분증에 기재된 대로 성명을 입력하십시오",
      "facility": "이 환자를 등록할 기관입니다. 해당 기관의 직원이 이 기록을 열람할 수 있습니다."
    },
    "flags": {
      "vipPatient": "VIP 환자",
      "medicalTourist": "의료관광객"
    },
    "duplicate": {
      "title": "중복 가능성이 있는 환자가 발견되었습니다",
      "body": "다음 기존 환자가 입력하신 정보와 일치합니다:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "일치도: {{score}}% ({{reasons}})",
      "useExisting": "기존 환자 사용",
      "createNew": "신규 환자로 등록",
      "restricted": {
        "title_one": "조회 권한이 없는 일치 후보가 {{count}}건 있습니다",
        "title_other": "조회 권한이 없는 일치 후보가 {{count}}건 있습니다",
        "body": "이 환자는 다른 기관에 이미 기록이 있을 수 있습니다. 새로 등록하기 전에 의무기록팀에 문의하십시오. 권한 밖의 기록이므로 세부 정보는 표시되지 않습니다."
      },
      "overrideReasonLabel": "그래도 등록하는 사유",
      "overrideReasonPlaceholder": "예: 다른 사람임을 환자에게 확인함",
      "overrideReasonHelp": "이 사유는 귀하의 계정에 기록됩니다. 동일인에게 두 개의 기록을 만들면 진료기록이 분리됩니다.",
      "registerAnyway": "그래도 등록"
    }
  },
  "search": {
    "title": "환자 검색",
    "subtitle": "환자 기록을 검색하고 관리합니다",
    "placeholder": "환자 이름, MRN 또는 ID로 검색...",
    "advancedFilters": "고급 필터",
    "filters": {
      "mrnPlaceholder": "예: P0000000001",
      "fullNamePlaceholder": "환자 이름",
      "phonePlaceholder": "전화번호",
      "emailPlaceholder": "이메일 주소"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "성명",
      "dateOfBirth": "생년월일",
      "phone": "전화",
      "email": "이메일",
      "country": "국가",
      "status": "상태",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "전체",
      "vipOnly": "VIP만",
      "nonVipOnly": "비 VIP만"
    },
    "statusFilter": {
      "all": "전체",
      "active": "활성",
      "inactive": "비활성"
    },
    "countryFilter": {
      "all": "전체 국가"
    },
    "clearFilters": "필터 지우기",
    "dateOfBirthAria": "생년월일 필터",
    "columns": {
      "mrn": "MRN",
      "fullName": "성명",
      "dob": "DOB",
      "gender": "성별",
      "phone": "전화",
      "country": "국가",
      "status": "상태"
    },
    "results": {
      "searching": "환자 검색 중...",
      "loadError": "환자를 불러오지 못했습니다. 다시 시도해 주십시오.",
      "retry": "다시 시도",
      "empty": "환자를 찾을 수 없습니다. 검색 조건을 조정해 주십시오.",
      "showing": "{{total}}명 중 {{from}}~{{to}}명 표시"
    }
  },
  "myPatients": {
    "title": "담당 환자",
    "subtitle": "담당 중인 활성 환자",
    "searchPlaceholder": "이름 또는 MRN으로 필터...",
    "columns": {
      "mrn": "MRN",
      "patient": "성명",
      "dob": "DOB",
      "sex": "성별",
      "class": "구분",
      "relationship": "관계",
      "admitted": "입원일시"
    },
    "kind": {
      "attending": "주치의",
      "careTeam": "진료팀",
      "referral": "의뢰",
      "coverage": "커버"
    },
    "restrictedBadge": "제한",
    "empty": {
      "title": "패널에 환자가 없습니다",
      "body": "담당·커버·의뢰로 맡은 환자가 여기에 표시됩니다.",
      "censusAction": "재원 명단 열기"
    },
    "results": {
      "searching": "담당 환자를 불러오는 중...",
      "loadError": "담당 환자를 불러오지 못했습니다. 다시 시도해 주십시오.",
      "retry": "다시 시도",
      "showing": "{{total}}명 중 {{from}}~{{to}}명 표시"
    }
  },
  "encounters": {
    "title": "방문 기록",
    "create": "방문 생성",
    "filters": "필터",
    "filterLabels": {
      "status": "상태",
      "class": "구분",
      "fromDate": "시작일",
      "toDate": "종료일"
    },
    "filterPlaceholders": {
      "allStatuses": "모든 상태",
      "allClasses": "모든 구분"
    },
    "clearFilters": "필터 지우기",
    "fromDateAria": "시작일",
    "toDateAria": "종료일",
    "columns": {
      "encounterNumber": "방문 번호",
      "class": "구분",
      "status": "상태",
      "admitDate": "입원일",
      "dischargeDate": "퇴원일",
      "location": "위치",
      "chiefComplaint": "주소(主訴)"
    },
    "locationLabel": "위치 #{{id}}",
    "loading": "방문 기록을 불러오는 중...",
    "loadError": "방문 기록을 불러오지 못했습니다.",
    "empty": "이 환자의 방문 기록이 없습니다.",
    "showing": "{{total}}건 중 {{from}}~{{to}}건 표시"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "신분증 유형",
      "none": "없음",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "태국 국민 신분증"
      },
      "country": {
        "nric": "싱가포르",
        "hkid": "홍콩",
        "myKad": "말레이시아",
        "aadhaar": "인도",
        "ktp": "인도네시아",
        "myNumber": "일본",
        "thaiNationalId": "태국"
      },
      "placeholderByType": {
        "nric": "예: S1234567D",
        "myKad": "예: 850101-14-5678",
        "hkid": "예: A123456(3)",
        "aadhaar": "예: 2341 2341 2346",
        "thaiNationalId": "예: 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "이 번호의 검증 문자가 일치하지 않습니다. 환자의 신분증에서 번호를 확인하세요.",
      "unavailable": "이 신분증 번호를 검증할 수 없습니다. 환자의 신분증에서 번호를 확인하세요.",
      "acknowledge": "신분증에서 이 번호를 확인했습니다",
      "acknowledgeRequired": "저장하기 전에 신분증에서 번호를 확인하고 체크하세요."
    }
  },
  "country": {
    "values": {
      "sg": "싱가포르",
      "my": "말레이시아",
      "th": "태국",
      "id": "인도네시아",
      "ph": "필리핀",
      "vn": "베트남",
      "hk": "홍콩",
      "tw": "대만",
      "jp": "일본",
      "kr": "대한민국",
      "cn": "중국",
      "in": "인도",
      "au": "호주",
      "nz": "뉴질랜드"
    }
  },
  "language": {
    "values": {
      "en": "영어",
      "zh": "중국어(만다린)",
      "ms": "말레이어",
      "ta": "타밀어",
      "th": "태국어",
      "id": "인도네시아어",
      "vi": "베트남어",
      "ja": "일본어",
      "ko": "한국어",
      "hi": "힌디어"
    }
  },
  "contact": {
    "addTitle": "연락처 추가",
    "editTitle": "연락처 편집",
    "name": "이름",
    "relationship": {
      "label": "관계",
      "selectPlaceholder": "선택...",
      "values": {
        "spouse": "배우자",
        "parent": "부모",
        "child": "자녀",
        "sibling": "형제자매",
        "guardian": "후견인",
        "friend": "친구",
        "other": "기타"
      }
    },
    "phone": "전화",
    "email": "이메일",
    "emergencyContact": "비상 연락처",
    "validation": {
      "nameRequired": "연락처 이름을 입력하십시오",
      "relationshipRequired": "관계를 선택하십시오",
      "phoneRequired": "전화번호를 입력하십시오",
      "invalidEmail": "이메일 형식이 올바르지 않습니다"
    },
    "savedSuccess": "연락처가 추가되었습니다",
    "saveError": "연락처 추가에 실패했습니다"
  },
  "immunization": {
    "addTitle": "예방접종 추가",
    "vaccineName": "백신 이름",
    "vaccineNamePlaceholder": "예: 인플루엔자, COVID-19 (Pfizer), B형 간염",
    "vaccineCode": "백신 코드 (CVX)",
    "vaccineCodePlaceholder": "예: 141",
    "administeredDate": "접종일",
    "lotNumber": "로트 번호",
    "lotNumberPlaceholder": "예: AB1234",
    "site": {
      "label": "접종 부위",
      "selectPlaceholder": "부위 선택",
      "values": {
        "leftDeltoid": "좌측 삼각근",
        "rightDeltoid": "우측 삼각근",
        "leftThigh": "좌측 대퇴부",
        "rightThigh": "우측 대퇴부",
        "leftGluteal": "좌측 둔부",
        "rightGluteal": "우측 둔부",
        "other": "기타"
      }
    },
    "route": {
      "label": "투여 경로",
      "selectPlaceholder": "경로 선택",
      "values": {
        "intramuscular": "근육주사 (IM)",
        "subcutaneous": "피하주사 (SC)",
        "intradermal": "피내주사 (ID)",
        "oral": "경구",
        "intranasal": "비강"
      }
    },
    "doseAmount": "용량",
    "doseAmountPlaceholder": "예: 0.5 mL",
    "administeredBy": "접종자",
    "administeredByPlaceholder": "의료진 이름 또는 ID",
    "nextDueDate": "다음 접종일",
    "notes": "비고",
    "notesPlaceholder": "추가 비고...",
    "validation": {
      "vaccineNameRequired": "백신 이름을 입력하십시오",
      "administeredDateRequired": "접종일을 입력하십시오"
    },
    "savedSuccess": "예방접종 기록이 추가되었습니다",
    "saveError": "예방접종 기록 추가에 실패했습니다"
  },
  "insurance": {
    "addTitle": "보험 플랜 추가",
    "submitLabel": "보험 추가",
    "payerName": "보험사명",
    "payerNamePlaceholder": "예: AIA 싱가포르",
    "payerId": "보험사 ID",
    "payerIdPlaceholder": "보험사 식별자",
    "planName": "플랜명",
    "planNamePlaceholder": "예: HealthShield Gold Max",
    "planType": {
      "label": "플랜 유형",
      "selectPlaceholder": "유형 선택",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "공보험",
        "private": "민간",
        "corporate": "단체",
        "other": "기타"
      }
    },
    "memberId": "가입자 ID",
    "memberIdPlaceholder": "가입자 ID 번호",
    "policyNumber": "증권 번호",
    "policyNumberPlaceholder": "증권 번호 입력",
    "groupNumber": "단체 번호",
    "groupNumberPlaceholder": "단체 번호",
    "subscriberName": "계약자 이름",
    "subscriberNamePlaceholder": "환자와 다를 경우 입력",
    "subscriberRelationship": {
      "label": "계약자와의 관계",
      "values": {
        "self": "본인",
        "spouse": "배우자",
        "child": "자녀",
        "parent": "부모",
        "other": "기타"
      }
    },
    "priority": {
      "label": "우선순위",
      "values": {
        "primary": "주",
        "secondary": "보조",
        "tertiary": "삼차"
      }
    },
    "effectiveDate": "개시일",
    "terminationDate": "종료일",
    "copayAmount": "본인부담금 ($)",
    "coinsurancePercent": "공동부담률 (%)",
    "deductibleAmount": "공제액 ($)",
    "outOfPocketMax": "본인부담 상한액 ($)",
    "preAuthRequired": "사전 승인 필요",
    "notes": "비고",
    "notesPlaceholder": "추가 비고...",
    "validation": {
      "payerNameRequired": "보험사명을 입력하십시오",
      "planNameRequired": "플랜명을 입력하십시오",
      "memberIdRequired": "가입자 ID를 입력하십시오",
      "effectiveDateRequired": "개시일을 입력하십시오"
    },
    "savedSuccess": "보험 플랜이 추가되었습니다",
    "saveError": "보험 플랜 추가에 실패했습니다"
  },
  "problem": {
    "addTitle": "문제 추가",
    "problemName": "문제 이름",
    "problemNamePlaceholder": "예: 제 2형 당뇨병",
    "icdCode": "ICD-10 코드",
    "icdSearchPlaceholder": "ICD-10 코드 또는 설명 검색...",
    "onsetDate": "발병일",
    "severity": {
      "label": "중증도",
      "values": {
        "mild": "경증",
        "moderate": "중등도",
        "severe": "중증"
      }
    },
    "notes": "비고",
    "notesPlaceholder": "추가 임상 비고...",
    "validation": {
      "problemNameRequired": "문제 이름을 입력하십시오"
    },
    "savedSuccess": "문제 목록에 추가되었습니다",
    "saveError": "문제 추가에 실패했습니다"
  },
  "accounts": {
    "pageTitle": "환자 계정",
    "backToDashboard": "대시보드",
    "searchPatientLabel": "환자 검색",
    "searchPlaceholder": "이름 또는 MRN으로 검색...",
    "searching": "검색 중...",
    "noPatientsFound": "환자를 찾을 수 없습니다",
    "loadingAccount": "계정 로딩 중...",
    "mrnLabel": "MRN",
    "generateStatement": "명세서 생성",
    "statementComingSoon": "명세서 생성 기능 곧 제공 예정",
    "paymentPlan": "지불 계획",
    "paymentPlanComingSoon": "지불 계획 설정 곧 제공 예정",
    "totalCharges": "총 청구액",
    "totalPayments": "총 납부액",
    "adjustments": "조정",
    "outstandingBalance": "미납 잔액",
    "transactionHistory": "거래 내역",
    "columns": {
      "date": "날짜",
      "type": "유형",
      "description": "내용",
      "amount": "금액",
      "balance": "잔액"
    },
    "transactionType": {
      "label": "유형",
      "values": {
        "charge": "청구",
        "payment": "납부",
        "adjustment": "조정"
      }
    },
    "loadingTransactions": "거래 로딩 중...",
    "noTransactionsFound": "거래 내역이 없습니다",
    "emptyState": "환자를 검색하여 계정을 확인하십시오"
  },
  "proxies": {
    "title": "공인 대리인",
    "description": "이 환자의 포털 데이터에 접근할 수 있도록 승인된 보호자, 후견인, 법정 대리인입니다. 취소된 항목은 감사를 위해 보관됩니다.",
    "addProxy": "대리인 추가",
    "newRelationshipHeading": "새 대리 관계",
    "proxyUserId": "대리 사용자 ID",
    "proxyUserIdPlaceholder": "사용자 ID(관리 → 사용자에서)",
    "proxyUserIdHelper": "관리 → 사용자에서 조회하십시오. 사용자 선택 기능은 후속 버전에서 제공됩니다.",
    "relationship": {
      "label": "관계",
      "values": {
        "parent": "부모",
        "legalGuardian": "법정 후견인",
        "spousePartner": "배우자 / 동반자",
        "adultChild": "성인 자녀",
        "powerOfAttorney": "위임대리인",
        "healthcareAgent": "의료 대리인"
      }
    },
    "accessLevel": {
      "label": "접근 권한",
      "values": {
        "full": "전체",
        "limited": "제한",
        "emergency": "응급"
      },
      "descriptions": {
        "full": "포털 전체 데이터 — 예약, 결과, 메시지, 양식.",
        "limited": "예약 및 메시지만(청소년에게 일반적).",
        "emergency": "환자가 의사 결정 능력을 상실한 경우 의료 대리인의 응급 접근 권한."
      }
    },
    "startDate": "시작일",
    "endDate": "종료일",
    "startDateAria": "유효 시작일",
    "endDateAria": "유효 종료일",
    "grantAccess": "대리 접근 권한 부여",
    "userIdRequired": "대리 사용자 ID가 필요합니다",
    "createdSuccess": "대리 관계가 생성되었습니다",
    "duplicateError": "이미 동일한 관계의 대리인으로 등록되어 있습니다",
    "invalidDataError": "대리 데이터가 유효하지 않습니다",
    "createError": "대리인 생성에 실패했습니다",
    "revokedSuccess": "대리 접근 권한이 취소되었습니다",
    "revokeError": "대리인 취소에 실패했습니다",
    "emptyState": "구성된 대리인이 없습니다. 위 버튼을 사용하여 보호자, 후견인, 의료 대리인에게 접근 권한을 부여하십시오.",
    "sections": {
      "active": "활성 ({{count}})",
      "plannedInactive": "예정 / 비활성 ({{count}})",
      "revoked": "취소됨 ({{count}})"
    },
    "userIdFallback": "사용자 #{{id}}",
    "noEndDate": "(종료일 없음)",
    "revokedOn": "{{date}} 취소",
    "revokeTitle": "대리 접근 권한 취소",
    "confirmRevokeTitle": "대리 접근 권한을 취소하시겠습니까?",
    "confirmRevokeBody": "{{name}}은(는) 이 환자의 포털 데이터 접근 권한을 즉시 잃게 됩니다. 기록은 감사 추적에 보관됩니다.",
    "confirmRevokeLabel": "접근 권한 취소"
  },
  "merge": {
    "title": "환자 병합",
    "description": "중복된 환자 기록을 병합합니다. 원본 환자는 비활성화되며 모든 임상 데이터는 대상(보존) 환자로 이동됩니다.",
    "sourceLabel": "원본 환자(비활성화됨)",
    "targetLabel": "대상 환자(보존되는 기록)",
    "clearSelection": "선택 해제",
    "searchPlaceholder": "이름, MRN 또는 전화번호로 검색...",
    "fields": {
      "mrn": "MRN",
      "dob": "생년월일",
      "gender": "성별",
      "country": "국가",
      "phone": "전화",
      "email": "이메일"
    },
    "counts": {
      "encounters": "진료: {{count}}",
      "allergies": "알레르기: {{count}}",
      "problems": "문제: {{count}}"
    },
    "samePatientWarning": "원본과 대상은 서로 다른 환자여야 합니다.",
    "comparisonTitle": "인구학적 정보 비교",
    "comparisonSubtitle": "차이점은 황색으로 강조 표시됩니다.",
    "columns": {
      "field": "항목",
      "source": "원본 ({{mrn}})",
      "target": "대상 ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "전체 이름",
      "mrn": "MRN",
      "dateOfBirth": "생년월일",
      "gender": "성별",
      "phone": "전화",
      "email": "이메일",
      "country": "국가",
      "nationalId": "주민등록번호"
    },
    "reasonLabel": "병합 사유",
    "reasonPlaceholder": "이 기록들을 병합하는 사유(필수)",
    "notesLabel": "비고(선택)",
    "notesPlaceholder": "이 병합에 대한 추가 비고",
    "mergeButton": "환자 병합",
    "mergeSuccess": "환자가 성공적으로 병합되었습니다",
    "mergeError": "환자 병합에 실패했습니다",
    "successHeading": "병합이 성공적으로 완료되었습니다.",
    "successBodyPrefix": "환자 {{mrn}}은(는) 비활성화되었습니다. 모든 임상 데이터는 ",
    "successBodySuffix": "(으)로 이동되었습니다.",
    "confirmTitle": "환자 병합 확인",
    "confirmBodyPrefix": "이 작업은",
    "confirmBodyEmphasis": "되돌릴 수 없습니다",
    "confirmBodySuffix": ". 환자 {{sourceMrn}} ({{sourceName}})은(는) 비활성화되며, 모든 임상 데이터는 환자 {{targetMrn}} ({{targetName}})(으)로 이동됩니다.",
    "confirmButton": "예, 환자 병합",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "환자 기록을 불러올 수 없습니다."
  },
  "allergy": {
    "addTitle": "알레르기 추가",
    "editTitle": "알레르기 편집",
    "allergen": "알레르기 유발 물질",
    "allergenPlaceholder": "예: 페니실린, 땅콩",
    "type": "유형",
    "typeOptions": {
      "drug": "약물",
      "food": "음식",
      "environmental": "환경"
    },
    "severityLabel": "중증도",
    "severity": {
      "mild": "경증",
      "moderate": "중등도",
      "severe": "중증",
      "lifeThreatening": "생명 위협"
    },
    "reaction": "반응",
    "reactionPlaceholder": "예: 두드러기, 아나필락시스, 구역",
    "reactionOptions": {
      "rash": "발진",
      "hives": "두드러기",
      "anaphylaxis": "아나필락시스",
      "swelling": "부종",
      "itching": "가려움",
      "other": "기타"
    },
    "onsetDate": "발생일",
    "notes": "비고",
    "notesPlaceholder": "추가 비고...",
    "verifiedBy": "확인자",
    "noKnownAllergies": "알려진 알레르기 없음",
    "savedSuccess": "알레르기가 추가되었습니다",
    "saveError": "알레르기 추가에 실패했습니다",
    "deletedSuccess": "알레르기가 제거되었습니다"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "브레이든 척도(욕창 위험)",
      "footer": "총점 범위: 6-23. 점수가 낮을수록 욕창 발생 위험이 높아집니다.",
      "scoreFormat": "점수: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "매우 높음 위험",
        "high": "높음 위험",
        "moderate": "중등도 위험",
        "mild": "경도 위험",
        "none": "위험 없음"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. 감각 인지",
          "options": {
            "1": "{{n}} - 완전 제한",
            "2": "{{n}} - 매우 제한",
            "3": "{{n}} - 약간 제한",
            "4": "{{n}} - 장애 없음"
          }
        },
        "moisture": {
          "label": "{{n}}. 습기",
          "options": {
            "1": "{{n}} - 지속적으로 습함",
            "2": "{{n}} - 자주 습함",
            "3": "{{n}} - 가끔 습함",
            "4": "{{n}} - 거의 습하지 않음"
          }
        },
        "activity": {
          "label": "{{n}}. 활동성",
          "options": {
            "1": "{{n}} - 침상 안정",
            "2": "{{n}} - 의자 안정",
            "3": "{{n}} - 가끔 보행",
            "4": "{{n}} - 자주 보행"
          }
        },
        "mobility": {
          "label": "{{n}}. 가동성",
          "options": {
            "1": "{{n}} - 완전 부동",
            "2": "{{n}} - 매우 제한",
            "3": "{{n}} - 약간 제한",
            "4": "{{n}} - 제한 없음"
          }
        },
        "nutrition": {
          "label": "{{n}}. 영양 상태",
          "options": {
            "1": "{{n}} - 매우 나쁨",
            "2": "{{n}} - 부족할 수 있음",
            "3": "{{n}} - 적절함",
            "4": "{{n}} - 우수함"
          }
        },
        "frictionShear": {
          "label": "{{n}}. 마찰과 전단력",
          "options": {
            "1": "{{n}} - 문제 있음",
            "2": "{{n}} - 잠재적 문제",
            "3": "{{n}} - 명백한 문제 없음"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "모스 낙상 척도",
      "scoreFormat": "점수: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. 낙상 기왕력",
          "options": {
            "0": "없음 ({{score}})",
            "25": "있음 ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. 이차 진단",
          "options": {
            "0": "없음 ({{score}})",
            "15": "있음 ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. 보행 보조",
          "options": {
            "0": "없음 / 침상 안정 / 간호사 보조 ({{score}})",
            "15": "목발 / 지팡이 / 보행기 ({{score}})",
            "30": "가구 의지 ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. 정맥주사 / 헤파린 락",
          "options": {
            "0": "없음 ({{score}})",
            "20": "있음 ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. 보행",
          "options": {
            "0": "정상 / 침상 안정 / 휠체어 ({{score}})",
            "10": "약함 ({{score}})",
            "20": "장애 ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. 정신 상태",
          "options": {
            "0": "자신의 능력을 정확히 인지 ({{score}})",
            "15": "능력 과대평가 / 한계 망각 ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "고위험 중재: 표준 낙상 예방 조치를 시행하십시오. 환자에게 낙상 위험 손목띠를 착용시키십시오. 침상 옆에 낙상 위험 표지를 게시하십시오. 환자와 가족을 교육하십시오. 침상을 최저 위치로 유지하고 브레이크를 잠그십시오. 호출벨이 손에 닿는 범위에 있는지 확인하십시오. 미끄럼 방지 신발. 배뇨 일정. 필요 시 1:1 감독을 고려하십시오.",
        "moderate": "중등도 위험 중재: 표준 낙상 예방 조치를 시행하십시오. 환자에게 낙상 위험 손목띠를 착용시키십시오. 환자와 가족을 교육하십시오. 침상을 최저 위치로 유지하고 브레이크를 잠그십시오. 호출벨이 손에 닿는 범위에 있는지 확인하십시오. 미끄럼 방지 신발.",
        "low": "저위험 중재: 양호한 기본 간호 제공. 환자에게 안전한 이동에 대해 교육. 환경 및 호출벨 사용에 대해 오리엔테이션."
      }
    }
  },
  "banner": {
    "label": "환자 정보",
    "vip": "VIP",
    "vipTitle": "VIP 환자",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "세",
    "sex": "성별",
    "codeStatusAria": "코드 상태: {{status}}",
    "isolationAria": "격리: {{status}}",
    "isolation": {
      "contact": "접촉 격리",
      "droplet": "비말 격리",
      "airborne": "공기 격리",
      "none": "없음"
    },
    "fallRiskAria": "낙상 위험: {{level}}",
    "fallRisk": {
      "label": "낙상 위험",
      "low": "낮음",
      "moderate": "보통",
      "high": "높음"
    },
    "pressureInjuryRisk": "욕창 위험",
    "pressureInjuryRiskAria": "욕창 위험: {{level}}",
    "interpreter": "통역",
    "interpreterRequired": "통역 필요 — {{language}}",
    "languageNotSpecified": "언어 미지정",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "알레르기",
    "moreAllergies_one": "+{{count}}개 더",
    "moreAllergies_other": "+{{count}}개 더",
    "nkda": "NKDA",
    "allergiesUnknown": "알레르기 알 수 없음 — 로드 실패"
  },
  "chartFrame": {
    "navAriaLabel": "환자 차트 탐색",
    "tabs": {
      "summary": "요약",
      "encounters": "방문 기록",
      "orders": "처방",
      "results": "검사 결과",
      "medications": "투약",
      "notes": "기록",
      "problems": "문제 목록",
      "allergies": "알레르기",
      "immunizations": "예방접종",
      "intakeOutput": "섭취/배설",
      "carePlans": "간호 계획",
      "referrals": "의뢰",
      "familyHistory": "가족력",
      "socialHistory": "사회력",
      "surgicalHistory": "수술력",
      "advanceDirectives": "사전 의료지시서",
      "insurance": "보험",
      "contacts": "연락처",
      "proxies": "대리인",
      "identifiers": "식별번호",
      "addresses": "주소",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "기기",
      "ccdaImports": "C-CDA 가져오기"
    },
    "groups": {
      "clinical": "임상",
      "history": "병력",
      "admin": "관리"
    },
    "breakGlass": {
      "auditBanner": "긴급 접근 — 모든 활동이 감사 기록됩니다. 접근은 15분 후 만료됩니다.",
      "dialogTitle": "제한된 환자 기록",
      "dialogSubtitle": "긴급 접근 권한이 필요합니다",
      "dialogBody": "이 환자 기록은 접근이 제한되어 있습니다. 접근하려면 사유를 입력해야 합니다. 모든 긴급 접근은 기록되고 감사됩니다.",
      "justificationLabel": "접근 사유",
      "justificationPlaceholder": "이 제한된 기록에 접근하는 임상적 사유를 입력하십시오...",
      "justificationRequired": "긴급 접근에는 사유 입력이 필요합니다.",
      "requestError": "긴급 접근 요청에 실패했습니다. 다시 시도하거나 관리자에게 문의하십시오.",
      "submitButton": "기록 접근",
      "submitting": "요청 중...",
      "passwordLabel": "비밀번호 확인",
      "passwordPlaceholder": "비밀번호를 다시 입력하세요",
      "passwordRequired": "긴급 접근에는 비밀번호가 필요합니다.",
      "passwordIncorrect": "비밀번호가 올바르지 않습니다. 다시 시도하세요.",
      "passwordHelp": "이 워크스테이션의 사용자가 본인임을 확인합니다.",
      "totpLabel": "인증 코드",
      "totpPlaceholder": "6자리 코드",
      "totpRequired": "긴급 접근에는 인증 앱 코드가 필요합니다.",
      "totpIncorrect": "코드가 올바르지 않습니다. 다시 시도하세요.",
      "totpHelp": "이 워크스테이션의 사용자가 본인임을 확인합니다.",
      "totpEnrollHint": "등록된 인증 앱이 없습니다——긴급 접근을 사용하려면 내 프로필에서 등록하세요."
    },
    "invalidId": {
      "title": "잘못된 환자 ID",
      "body": "제공된 환자 ID가 유효하지 않습니다.",
      "action": "환자 검색"
    },
    "notFound": {
      "title": "환자를 찾을 수 없음",
      "body": "환자 데이터를 불러올 수 없습니다. 환자가 존재하지 않거나 접근 권한이 없을 수 있습니다.",
      "action": "환자 검색"
    },
    "loadError": {
      "title": "환자 차트를 불러오지 못했습니다",
      "body": "차트를 불러올 수 없습니다. 다시 시도해 주세요.",
      "action": "다시 시도"
    }
  },
  "address": {
    "title": "주소",
    "addAddress": "주소 추가",
    "newTitle": "새 주소",
    "editTitle": "주소 편집",
    "loading": "주소를 불러오는 중...",
    "loadError": "주소 정보를 불러오지 못했습니다.",
    "empty": "등록된 주소가 없습니다.",
    "addressType": {
      "label": "유형",
      "values": {
        "home": "자택",
        "work": "직장",
        "temporary": "임시",
        "billing": "청구지"
      }
    },
    "fields": {
      "addressLine1": "주소 1행",
      "addressLine2": "주소 2행",
      "addressLine3": "주소 3행",
      "district": "구/군",
      "city": "시",
      "stateProvince": "도/주",
      "postalCode": "우편번호",
      "country": "국가"
    },
    "placeholders": {
      "addressLine1": "도로명 주소",
      "addressLine2": "동, 호수, 층",
      "addressLine3": "건물, 단지",
      "district": "구/면",
      "postalCode": "예: 06236",
      "country": "예: KR"
    },
    "primaryBadge": "기본",
    "setPrimary": "기본 주소로 설정",
    "primaryHelper": "(다른 주소의 기본 설정은 해제됩니다)",
    "fromLabel": "시작: {{date}}",
    "toLabel": "종료: {{date}}",
    "save": "저장",
    "update": "업데이트",
    "cancel": "취소",
    "editTooltip": "주소 편집",
    "removeTooltip": "주소 삭제",
    "addedSuccess": "주소가 추가되었습니다",
    "addError": "주소 추가에 실패했습니다",
    "updatedSuccess": "주소가 업데이트되었습니다",
    "updateError": "주소 업데이트에 실패했습니다",
    "removedSuccess": "주소가 삭제되었습니다",
    "removeError": "주소 삭제에 실패했습니다",
    "requiredError": "주소 1행과 국가는 필수입니다",
    "confirmRemoveTitle": "주소 삭제",
    "confirmRemoveMessage": "이 {{type}} 주소를 삭제하시겠습니까?",
    "confirmRemoveLabel": "삭제"
  },
  "allergies": {
    "pageTitle": "알레르기",
    "addAllergy": "알레르기 추가",
    "loading": "알레르기를 불러오는 중...",
    "loadError": "알레르기 정보를 불러오지 못했습니다.",
    "nka": {
      "title": "알려진 알레르기 없음 (NKA)",
      "body": "이 환자의 알레르기가 기록되어 있지 않습니다."
    },
    "sections": {
      "active": "활성 알레르기 ({{count}})",
      "inactive": "비활성 알레르기 ({{count}})"
    },
    "fields": {
      "reaction": "반응",
      "severity": "중증도",
      "onset": "발현",
      "recorded": "기록일"
    },
    "inactiveSummary": "반응: {{reaction}} | 중증도: {{severity}}",
    "deactivate": "비활성화",
    "deactivateTooltip": "알레르기 비활성화",
    "deleteTooltip": "알레르기 삭제",
    "deactivatedSuccess": "알레르기가 비활성화되었습니다",
    "deactivateError": "알레르기 비활성화에 실패했습니다",
    "removedSuccess": "알레르기가 삭제되었습니다",
    "removeError": "알레르기 삭제에 실패했습니다",
    "confirmDeactivateTitle": "비활성화 확인",
    "confirmDeactivateMessage": "\"{{name}}\"을(를) 비활성화하시겠습니까?",
    "confirmDeleteTitle": "삭제 확인",
    "confirmDeleteMessage": "\"{{name}}\"을(를) 영구적으로 삭제하시겠습니까?",
    "confirmLabel": "확인"
  },
  "problems": {
    "pageTitle": "문제 목록",
    "addProblem": "문제 추가",
    "loading": "문제 목록을 불러오는 중...",
    "loadError": "문제 목록을 불러오지 못했습니다.",
    "tabs": {
      "active": "활성 ({{count}})",
      "resolvedInactive": "해결/비활성 ({{count}})"
    },
    "sortByLabel": "정렬:",
    "sortBy": {
      "onsetDate": "발현 날짜",
      "severity": "중증도"
    },
    "status": {
      "label": "상태",
      "values": {
        "active": "활성",
        "resolved": "해결",
        "inactive": "비활성"
      }
    },
    "empty": {
      "active": "활성 문제 기록이 없습니다.",
      "resolved": "해결 또는 비활성 문제가 없습니다."
    },
    "fields": {
      "onset": "발현",
      "resolved": "해결"
    },
    "resolveButton": "해결",
    "reactivateButton": "재활성화",
    "resolveTooltip": "해결됨으로 표시",
    "reactivateTooltip": "재활성화",
    "statusUpdatedSuccess": "문제 상태가 업데이트되었습니다",
    "statusUpdateError": "문제 상태 업데이트에 실패했습니다"
  },
  "immunizations": {
    "pageTitle": "예방접종",
    "addImmunization": "예방접종 추가",
    "loading": "예방접종 기록을 불러오는 중...",
    "loadError": "예방접종 기록을 불러오지 못했습니다.",
    "empty": "예방접종 기록이 없습니다.",
    "dueOverdue": "접종 예정/지연 ({{count}})",
    "upcoming": "예정된 예방접종 ({{count}})",
    "dueLabel": "예정일: {{date}}",
    "fromDateLabel": "시작일",
    "toDateLabel": "종료일",
    "fromDateAria": "예방접종 시작일",
    "toDateAria": "예방접종 종료일",
    "clearFilters": "지우기",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "백신",
      "date": "접종일",
      "lotNumber": "로트 번호",
      "site": "부위",
      "administeredBy": "접종자",
      "nextDue": "다음 예정",
      "status": "상태"
    },
    "dueStatus": {
      "label": "상태",
      "values": {
        "overdue": "지연",
        "dueToday": "오늘 예정",
        "upcoming": "예정"
      }
    }
  },
  "contacts": {
    "pageTitle": "연락처",
    "addContact": "연락처 추가",
    "loading": "연락처를 불러오는 중...",
    "loadError": "연락처 정보를 불러오지 못했습니다.",
    "empty": "등록된 연락처가 없습니다.",
    "emergencyBadge": "긴급",
    "sections": {
      "emergency": "긴급 연락처 ({{count}})",
      "other": "기타 연락처 ({{count}})"
    },
    "editTooltip": "연락처 편집",
    "deleteTooltip": "연락처 삭제",
    "deletedSuccess": "연락처가 삭제되었습니다",
    "deleteError": "연락처 삭제에 실패했습니다",
    "confirmDeleteTitle": "연락처 삭제",
    "confirmDeleteMessage": "\"{{name}}\"을(를) 삭제하시겠습니까?",
    "confirmDeleteLabel": "삭제"
  },
  "insurances": {
    "pageTitle": "보험",
    "addInsurance": "보험 추가",
    "loading": "보험 정보를 불러오는 중...",
    "loadError": "보험 정보를 불러오지 못했습니다.",
    "empty": {
      "title": "보험 플랜 없음",
      "body": "이 환자의 보험 플랜이 기록되어 있지 않습니다."
    },
    "sections": {
      "active": "활성 플랜 ({{count}})",
      "inactive": "비활성 플랜 ({{count}})"
    },
    "status": {
      "label": "상태",
      "values": {
        "active": "활성",
        "inactive": "비활성",
        "pendingVerification": "확인 대기 중"
      }
    },
    "fields": {
      "memberId": "회원 ID",
      "groupNumber": "단체 번호",
      "effectiveDate": "발효일",
      "terminationDate": "종료일",
      "copay": "본인 부담",
      "coinsurance": "공동 부담",
      "deductible": "공제액",
      "subscriber": "가입자"
    },
    "preAuthBadge": "사전 승인 필요",
    "lastVerifiedLabel": "최종 확인: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "확인",
    "verifyTooltip": "자격 확인",
    "editButton": "편집",
    "verifySuccess": "자격 확인이 시작되었습니다",
    "verifyError": "자격 확인에 실패했습니다"
  },
  "identifiersTab": {
    "pageTitle": "식별번호",
    "addIdentifier": "식별번호 추가",
    "loading": "식별번호를 불러오는 중...",
    "loadError": "식별번호 정보를 불러오지 못했습니다.",
    "empty": "등록된 식별번호가 없습니다.",
    "newTitle": "새 식별번호",
    "type": {
      "label": "유형",
      "selectPlaceholder": "유형 선택...",
      "values": {
        "externalMrn": "외부 MRN",
        "insuranceId": "보험번호",
        "studyId": "연구번호",
        "healthCard": "건강보험증",
        "nationalRegistry": "주민등록번호",
        "passport": "여권",
        "driverLicense": "운전면허증",
        "other": "기타"
      }
    },
    "fields": {
      "value": "번호",
      "assigningAuthority": "발행 기관",
      "effectiveDate": "발효일",
      "expiryDate": "만료일"
    },
    "placeholders": {
      "value": "예: 123456-1234567",
      "assigningAuthority": "예: 보건복지부"
    },
    "status": {
      "label": "상태",
      "values": {
        "active": "활성",
        "inactive": "비활성"
      }
    },
    "columns": {
      "type": "유형",
      "value": "번호",
      "assigningAuthority": "발행 기관",
      "effectiveDate": "발효일",
      "expiryDate": "만료일",
      "status": "상태",
      "actions": "작업"
    },
    "save": "저장",
    "cancel": "취소",
    "removeTooltip": "식별번호 삭제",
    "addedSuccess": "식별번호가 추가되었습니다",
    "addError": "식별번호 추가에 실패했습니다",
    "removedSuccess": "식별번호가 삭제되었습니다",
    "removeError": "식별번호 삭제에 실패했습니다",
    "requiredError": "유형과 번호는 필수입니다",
    "confirmRemoveTitle": "식별번호 삭제",
    "confirmRemoveMessage": "\"{{type}}: {{value}}\"을(를) 삭제하시겠습니까?",
    "confirmRemoveLabel": "삭제"
  },
  "pages": {
    "advanceDirectives": {
      "title": "사전의료지시서",
      "addButton": "지시서 추가",
      "emptyState": "이 환자에 대해 기록된 사전의료지시서가 없습니다.",
      "loading": "사전의료지시서를 불러오는 중...",
      "loadError": "사전의료지시서를 불러오지 못했습니다.",
      "documentLink": "문서 보기",
      "effectivePrefix": "시행:",
      "reviewPrefix": "재검토:",
      "form": {
        "title": "새 사전의료지시서",
        "labels": {
          "directiveType": "지시서 유형",
          "status": "상태",
          "effectiveDate": "시행일",
          "notes": "비고",
          "optional": "선택"
        },
        "placeholders": {
          "notes": "지시서에 대한 추가 비고..."
        },
        "selectTypePlaceholder": "유형을 선택하세요...",
        "aria": {
          "effectiveDate": "시행일"
        },
        "buttons": {
          "save": "지시서 저장",
          "cancel": "취소"
        }
      },
      "directiveType": {
        "DNR": "심폐소생술 거부(DNR)",
        "living-will": "사전연명의료의향서",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "의료 대리인",
        "power-of-attorney": "지속적 위임장"
      },
      "directiveStatus": {
        "active": "유효",
        "inactive": "무효",
        "revoked": "철회됨",
        "pending": "재검토 대기"
      },
      "toast": {
        "added": "사전의료지시서가 추가되었습니다",
        "addFailed": "사전의료지시서 추가에 실패했습니다",
        "directiveTypeRequired": "지시서 유형은 필수입니다"
      }
    },
    "familyHistory": {
      "title": "가족력",
      "addButton": "항목 추가",
      "emptyState": "이 환자의 가족력이 기록되어 있지 않습니다.",
      "loading": "가족력을 불러오는 중...",
      "loadError": "가족력 불러오기에 실패했습니다.",
      "onsetAge": "발병 연령: {{age}}세",
      "outcomePrefix": "결과:",
      "form": {
        "title": "새 가족력 항목",
        "labels": {
          "relationship": "관계",
          "conditionName": "질환명",
          "conditionCode": "질환 코드",
          "onsetAge": "발병 연령",
          "outcome": "결과",
          "optional": "선택"
        },
        "placeholders": {
          "onsetAge": "연령(세)"
        },
        "selectRelationshipPlaceholder": "관계를 선택하세요...",
        "selectOutcomePlaceholder": "결과를 선택하세요...",
        "buttons": {
          "save": "항목 저장",
          "cancel": "취소"
        }
      },
      "relationship": {
        "Mother": "어머니",
        "Father": "아버지",
        "Sibling": "형제자매",
        "Maternal Grandmother": "외할머니",
        "Maternal Grandfather": "외할아버지",
        "Paternal Grandmother": "할머니",
        "Paternal Grandfather": "할아버지",
        "Child": "자녀",
        "Aunt": "이모/고모",
        "Uncle": "삼촌/외삼촌/이모부"
      },
      "outcome": {
        "alive": "생존",
        "deceased": "사망",
        "unknown": "알 수 없음"
      },
      "toast": {
        "added": "가족력 항목이 추가되었습니다",
        "addFailed": "가족력 항목 추가에 실패했습니다",
        "relationshipAndConditionRequired": "관계와 질환명은 필수 항목입니다"
      }
    },
    "socialHistory": {
      "title": "사회력",
      "editButton": "편집",
      "loading": "사회력 불러오는 중...",
      "loadError": "사회력 불러오기에 실패했습니다.",
      "labels": {
        "smokingStatus": "흡연 상태",
        "alcoholUse": "음주",
        "substanceUse": "약물 사용",
        "housing": "거주 상황",
        "employment": "고용 상태",
        "safetyScreening": "안전 스크리닝",
        "notes": "메모"
      },
      "placeholders": {
        "notes": "추가 메모..."
      },
      "buttons": {
        "save": "변경 사항 저장",
        "cancel": "취소"
      },
      "toast": {
        "updated": "사회력이 업데이트되었습니다",
        "updateFailed": "사회력 업데이트에 실패했습니다"
      },
      "smokingStatus": {
        "never": "비흡연자",
        "former": "과거 흡연자",
        "currentDaily": "현재 흡연자(매일)",
        "currentOccasional": "현재 흡연자(가끔)",
        "unknown": "불명"
      },
      "alcoholUse": {
        "None": "없음",
        "Social/Occasional": "사교적/가끔",
        "Moderate": "보통",
        "Heavy": "과음",
        "In Recovery": "회복 중",
        "Unknown": "불명"
      },
      "substanceUse": {
        "None": "없음",
        "Current Use": "현재 사용 중",
        "Former Use": "과거 사용",
        "In Treatment": "치료 중",
        "Unknown": "불명"
      },
      "housing": {
        "Stable": "안정",
        "Unstable": "불안정",
        "Homeless": "노숙",
        "Assisted Living": "보조 생활 시설",
        "Nursing Facility": "요양 시설",
        "Unknown": "불명"
      },
      "employment": {
        "Employed Full-Time": "정규직 고용",
        "Employed Part-Time": "비정규직 고용",
        "Self-Employed": "자영업",
        "Unemployed": "실업",
        "Retired": "퇴직",
        "Student": "학생",
        "Disabled": "장애로 인한 무직",
        "Unknown": "불명"
      },
      "safetyScreening": {
        "No Concerns": "우려 없음",
        "Concerns Identified": "우려 확인됨",
        "Declined to Answer": "답변 거부",
        "Not Screened": "스크리닝 미실시"
      }
    },
    "surgicalHistory": {
      "title": "수술 이력",
      "addButton": "수술 추가",
      "emptyState": "이 환자에 대한 수술 이력 기록이 없습니다.",
      "loading": "수술 이력 로딩 중...",
      "loadError": "수술 이력을 불러올 수 없습니다.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "일자: {{date}}",
      "surgeonLabel": "집도의: {{name}}",
      "anesthesiaLabel": "마취: {{type}}",
      "outcomePrefix": "결과:",
      "complicationsPrefix": "합병증:",
      "form": {
        "title": "신규 수술 이력 항목",
        "labels": {
          "procedureName": "수술명",
          "procedureCode": "수술 코드",
          "procedureCodeSuffix": "(CPT)",
          "date": "일자",
          "surgeonName": "집도의 이름",
          "anesthesiaType": "마취 종류",
          "laterality": "좌우",
          "outcome": "결과",
          "complications": "합병증"
        },
        "placeholders": {
          "surgeonName": "집도의 이름",
          "complications": "합병증이 있는 경우..."
        },
        "selectPlaceholder": "선택...",
        "aria": {
          "procedureDate": "수술 일자"
        },
        "buttons": {
          "save": "항목 저장",
          "cancel": "취소"
        }
      },
      "anesthesiaType": {
        "general": "전신마취",
        "regional": "부위마취",
        "local": "국소마취",
        "spinal": "척추마취",
        "epidural": "경막외마취",
        "sedation": "진정",
        "none": "없음",
        "unknown": "불명"
      },
      "laterality": {
        "left": "좌측",
        "right": "우측",
        "bilateral": "양측"
      },
      "toast": {
        "added": "수술 이력 항목이 추가되었습니다",
        "addFailed": "수술 이력 항목 추가에 실패했습니다",
        "procedureNameRequired": "수술명은 필수 항목입니다"
      }
    },
    "referralManagement": {
      "title": "의뢰",
      "addButton": "신규 의뢰",
      "refresh": "새로고침",
      "loading": "의뢰 로드 중...",
      "errorState": "의뢰를 로드하지 못했습니다.",
      "emptyState": "이 환자에 대한 의뢰 기록이 없습니다.",
      "emptyStateFiltered": "선택한 상태에 해당하는 의뢰가 없습니다.",
      "ariaFilterStatus": "상태별로 의뢰 필터",
      "externalBadge": "외부",
      "filterStatus": {
        "allLabel": "모든 상태"
      },
      "table": {
        "type": "유형",
        "reason": "사유",
        "specialty": "전문과",
        "priority": "우선순위",
        "status": "상태",
        "requested": "신청일",
        "target": "목표일"
      },
      "form": {
        "title": "신규 의뢰",
        "labels": {
          "referralType": "의뢰 유형",
          "priority": "우선순위",
          "specialty": "전문과",
          "reason": "사유",
          "targetDate": "목표일",
          "clinicalNotes": "임상 메모",
          "optional": "선택"
        },
        "placeholders": {
          "reason": "의뢰 사유",
          "clinicalNotes": "추가 임상 메모..."
        },
        "selectReferralTypePlaceholder": "유형 선택...",
        "selectSpecialtyPlaceholder": "전문과 선택...",
        "buttons": {
          "create": "의뢰 생성",
          "cancel": "취소"
        }
      },
      "referralType": {
        "consultation": "협진",
        "transfer": "전원",
        "second-opinion": "세컨드 오피니언",
        "diagnostic": "진단",
        "therapeutic": "치료"
      },
      "priority": {
        "routine": "일반",
        "urgent": "응급",
        "stat": "STAT"
      },
      "status": {
        "draft": "초안",
        "submitted": "제출됨",
        "accepted": "수락됨",
        "scheduled": "예약됨",
        "completed": "완료",
        "cancelled": "취소됨"
      },
      "toasts": {
        "createSuccess": "의뢰가 생성되었습니다",
        "createFailed": "의뢰 생성에 실패했습니다",
        "validationFailed": "의뢰 유형과 사유는 필수입니다"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "조회 권한이 없는 환자가 포함된 쌍이 {{count}}건 있습니다",
      "title_other": "조회 권한이 없는 환자가 포함된 쌍이 {{count}}건 있습니다",
      "body": "담당 환자가 다른 기관의 기록과 중복일 수 있습니다. 판단하려면 권한 밖의 환자를 조회해야 하므로 목록에 표시되지 않습니다. 의무기록팀에 검토를 요청하십시오."
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "기록 내보내기",
    "exporting": "내보내는 중…",
    "success": "기록을 내보냈습니다",
    "failed": "내보내기 실패 — 다운로드된 항목이 없습니다",
    "tooltip": "이 환자의 전체 진료 기록을 이식 가능한 파일로 다운로드합니다"
  },
  "device": {
    "addTitle": "이식 기기 기록",
    "editTitle": "제거 기록",
    "deviceName": "기기명",
    "deviceNamePlaceholder": "예: Evera MRI ICD, 약물방출 스텐트",
    "deviceNameTooLong": "기기명은 512자를 초과할 수 없습니다",
    "deviceType": "기기 유형",
    "deviceTypePlaceholder": "예: 심박조율기, 스텐트, 인공관절",
    "udi": "UDI",
    "udiPlaceholder": "의료기기 고유식별자",
    "deviceCode": "기기 코드",
    "deviceCodeSystem": "코드 체계",
    "deviceCodeSystemPlaceholder": "예: GMDN, SNOMED CT",
    "manufacturer": "제조사",
    "modelNumber": "모델",
    "lotNumber": "로트 번호",
    "serialNumber": "일련번호",
    "implantDate": "이식일",
    "explantDate": "제거일",
    "status": "상태",
    "statusOptions": {
      "active": "사용 중",
      "inactive": "미사용",
      "explanted": "제거됨"
    },
    "mriSafety": "MRI 안전성",
    "mriSafetyOptions": {
      "safe": "안전",
      "conditional": "조건부",
      "unsafe": "위험",
      "unknown": "알 수 없음"
    },
    "notes": "비고",
    "notesPlaceholder": "추가 비고...",
    "savedSuccess": "기기를 기록했습니다",
    "saveError": "기기 기록에 실패했습니다",
    "updatedSuccess": "제거를 기록했습니다",
    "updateError": "제거 기록에 실패했습니다",
    "explantRequiresDate": "제거된 기기에는 제거일이 필요합니다",
    "explantBeforeImplant": "제거일은 이식일보다 빠를 수 없습니다"
  },
  "devices": {
    "pageTitle": "이식 기기",
    "addDevice": "기기 기록",
    "loading": "기기를 불러오는 중...",
    "loadError": "기기 정보를 불러오지 못했습니다.",
    "empty": {
      "title": "이식 기기 없음",
      "body": "이 환자에게 기록된 기기가 없습니다."
    },
    "sections": {
      "active": "사용 중인 기기 ({{count}})",
      "history": "제거됨 / 미사용 ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "제조사",
      "implanted": "이식",
      "explanted": "제거",
      "mriSafety": "MRI 안전성",
      "recorded": "기록일"
    },
    "recordExplant": "제거 기록",
    "explantTooltip": "이 기기의 제거를 기록",
    "removeTooltip": "항목 삭제",
    "removedSuccess": "기기 항목을 삭제했습니다",
    "removeError": "기기 항목 삭제에 실패했습니다",
    "confirmDeleteTitle": "삭제 확인",
    "confirmDeleteMessage": "목록에서 \"{{name}}\"을(를) 삭제하시겠습니까? 잘못 기록된 항목만 삭제하세요 — 체내에서의 제거 기록에는 제거 기록을 사용하세요.",
    "confirmLabel": "확인"
  },
  "ccdaImports": {
    "title": "C-CDA 가져오기",
    "subtitle": "조정을 위해 수신된 문서. 임포트를 열어 각 항목을 차트에 반영합니다.",
    "empty": "이 환자의 가져온 문서가 없습니다.",
    "loadError": "임포트를 불러오지 못했습니다.",
    "received": "수신",
    "docType": "종류",
    "status": "상태",
    "pending": "대기 중",
    "entries": "항목",
    "match": "일치",
    "mismatch": "ID 불일치",
    "statuses": {
      "pending": "대기 중",
      "reviewed": "검토됨",
      "dismissed": "기각됨"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "의뢰서",
      "discharge-summary": "퇴원요약서",
      "other": "기타"
    }
  },
  "ccdaReview": {
    "title": "임포트 #{{id}}",
    "back": "임포트 목록으로",
    "loadError": "이 임포트를 불러오지 못했습니다.",
    "mismatchWarning": "발신자 식별자가 이 환자와 일치하지 않습니다. 수락하기 전에 문서 귀속을 확인하십시오.",
    "unnamed": "이름 없음",
    "accept": "수락",
    "reject": "거부",
    "accepted": "차트에 병합되었습니다",
    "rejected": "항목이 거부되었습니다",
    "alreadyReviewed": "다른 사용자가 이미 검토함 — 아래 새로고침됨",
    "reviewError": "검토 실패",
    "confirmAcceptTitle": "차트에 수락하시겠습니까?",
    "confirmAcceptMessage": "“{{name}}”이(가) 이 환자 차트에 추가됩니다.",
    "confirmRejectTitle": "이 항목을 거부하시겠습니까?",
    "confirmRejectMessage": "“{{name}}”이(가) 대기열에서 제외됩니다. 원문서는 보관됩니다.",
    "sections": {
      "problem": "문제",
      "medication": "약물",
      "allergy": "알레르기"
    },
    "statuses": {
      "accepted": "수락됨",
      "rejected": "거부됨"
    }
  }
}
